import type {
  DistortionResult,
  DistortionServiceOptions,
} from "./distortion-processing";
import { serviceContainer } from "./serviceContainer";
import type {
  GetReversePixelMapperFactoryArgs,
  ReversePixelMapperFactoriesPoolKeyMap,
  ReversePixelMapper,
} from "./pixel-mapper";
import type { ImageAdapter } from "./image-adapter";

/**
 * Distorts image using distortion name and distortion arguments.
 *
 * @param image
 * @param distortion
 * @param args
 * @param options
 */
export function distort<
  ResourceType,
  K extends keyof ReversePixelMapperFactoriesPoolKeyMap
>(
  image: ResourceType | ImageAdapter<ResourceType>,
  distortion: K,
  args: GetReversePixelMapperFactoryArgs<K>,
  options?: DistortionServiceOptions
): Promise<DistortionResult<ResourceType>>;

/**
 * Distorts image using ReversePixelMapper instance.
 *
 * @param image
 * @param reversePixelMapper
 * @param options
 */
export function distort<ResourceType>(
  image: ResourceType | ImageAdapter<ResourceType>,
  reversePixelMapper: ReversePixelMapper,
  options?: DistortionServiceOptions
): Promise<DistortionResult<ResourceType>>;

/**
 * distort() implementation.
 *
 * @param image
 * @param distortionOrMapper
 * @param argsOrOptions
 * @param mayBeOptions
 */
export function distort<ResourceType>(
  image: ResourceType | ImageAdapter<ResourceType>,
  distortionOrMapper:
    | keyof ReversePixelMapperFactoriesPoolKeyMap
    | string
    | ReversePixelMapper,
  argsOrOptions: number[] | DistortionServiceOptions | undefined,
  mayBeOptions?: DistortionServiceOptions
): Promise<DistortionResult<ResourceType>> {
  return serviceContainer
    .resolve("DistortionService")
    .distort(image, distortionOrMapper, argsOrOptions, mayBeOptions);
}
